import { ArrowRight } from "lucide-react";
import { BRAND } from "../../config/site";
import { ROUTES } from "../../config/routes";
import { CtaLink } from "../common/CtaLink";

export const CtaBand = () => (
  <section className="section-pad border-t border-white/5">
    <div className="container-x">
      <div className="relative overflow-hidden rounded-3xl border border-white/10 bg-[#0F111A] p-10 sm:p-14 lg:p-20">
        <div className="absolute -right-24 -top-24 h-72 w-72 rounded-full bg-[#FF5500]/15 blur-3xl" aria-hidden="true" />
        <p className="label-mono text-[#FF5500]">{BRAND.positioning}</p>
        <h2 className="mt-5 max-w-2xl font-display text-3xl font-extrabold uppercase leading-tight tracking-tight text-slate-50 sm:text-4xl lg:text-5xl">{BRAND.tagline}</h2>
        <div className="mt-10 flex flex-col gap-3 sm:flex-row">
          <CtaLink to={ROUTES.PRICING} testId="cta-band-get-carlink" className="justify-center">Get CARLINK <ArrowRight className="h-4 w-4" /></CtaLink>
          <CtaLink to={ROUTES.CONTACT} variant="ghost" testId="cta-band-contact" className="justify-center">Talk to us</CtaLink>
        </div>
      </div>
    </div>
  </section>
);
